import React, { useState, useEffect } from "react"
import "./GoogleTranslateWidget.scss"
import { Button } from "react-bootstrap"
import $ from "jquery"

const GoogleTranslate = props => {
  const [isRussian, setIsRussian] = useState(
    typeof window !== "undefined"
      ? localStorage.getItem("language") == "ru"
        ? true
        : false
      : null
  )
  const [isRender, setIsRender] = useState(false)
  let language =
    typeof window !== "undefined" ? localStorage.getItem("language") : null

  const googleTranslateElementInit = () => {
    if (window.google.translate) {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages: "en,ru",
        },
        "google_translate_element"
      )
    }
  }

  const handleChange = lang => {
    var select = document.querySelector(".goog-te-combo")
    select.value = lang
    select.dispatchEvent(new Event("change"))
    if (typeof window !== "undefined") {
      localStorage.setItem("language", lang)
      setIsRussian(localStorage.getItem("language") == "ru" ? true : false)
    }
    setTimeout(() => {
      var select = document.querySelector(".goog-te-combo")
      if (select.value === "") {
        select.value = lang
        select.dispatchEvent(new Event("change"))
      }
    }, 500)

    if (lang === "ru") {
      document.body.classList.add("russian-class")
      document.body.classList.remove("default-class")
      document.body.classList.remove("eng-class")
    } else if (lang === "en") {
      document.body.classList.add("eng-class")
      document.body.classList.remove("russian-class")
    }
  }

  useEffect(() => {
    if (!isRender) {
      var setTime = 0
      let dom = document.location.pathname
      if (
        dom.indexOf("/properties/for-sale") > -1 ||
        dom.indexOf("/properties/for-rent") > -1 ||
        dom.indexOf("/properties/commercial/for-sale") > -1 ||
        dom.indexOf("/properties/commercial/for-rent") > -1
      ) {
        setTime = 1000
      }
      setTimeout(() => {
        var addScript = document.createElement("script")
        addScript.setAttribute(
          "src",
          "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
        )
        document.body.appendChild(addScript)

        window.googleTranslateElementInit = googleTranslateElementInit
      }, setTime)

      if (language === "ru") {
        document.body.classList.add("russian-class")
        document.body.classList.remove("default-class")
        document.body.classList.remove("eng-class")
      } else if (language === "en") {
        document.body.classList.add("eng-class")
        document.body.classList.remove("russian-class")
      }

      setTimeout(() => {
        $("#goog-gt-").remove();
      }, 2000)

        
      setIsRender(true)
    }
  })

  return (
    <div className="google-translate-widget-element">
      <div id="google_translate_element" className={`d-none`}></div>
      <Button
        onClick={e => handleChange(isRussian ? "en" : "ru")}
        className="translate_button notranslate"
      >
        {isRussian ? "EN" : "RU"}
      </Button>
    </div>
  )
}

export default GoogleTranslate
